export const environment = {
  production: true,
  back: 'https://editor-recette.config.cosling.com/api/',
  front: 'https://editor-recette.config.cosling.com/',
  keycloak_url: 'https://keycloak.cosling.com',
  keycloak_realm_id: 'recette',
  keycloak_client_id: 'recette_config',
};
